<template>
  <info-card :fa="fa" :title="title" :text="text" :bgvariant="bgvariant" :textvariant="textvariant" :placeholder="placeholder">
    <div class="mt-5 mb-5 row info-card-custom-content">
      <div class="col content-item" v-for="item in contentItems" :key="item.text">
        <div class="title">
          <h3 class="font-weight-bold">{{ item.title }}</h3>
          <div class="ml-2 vertical-allign-super" v-if="item.icon">
            <b-badge :variant="item.iconVariant">
              <i :class="'fa ' + item.icon" aria-hidden="true"></i>
            </b-badge>
          </div>
        </div>
        <div class="d-flex mt-4 content">
          <div class="font-weight-bold mr-2" v-if="item.type == 'url'">
            <a target="_blank" :href="item.text">{{ item.text }}</a>
          </div>
          <div class="text-muted" v-if="item.type == 'text'">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </info-card>
</template>

<script>
import InfoCard from "../../components/organisms/InfoCard.vue";

export default {
  name: "dashboard-item",
  props: {
    contentItems: {
      type: Array,
      required: true
    },

    fa: {
      type: String,
      required: true,
    },

    bgvariant: {
      type: String,
      required: true,
    },

    textvariant: {
      type: String,
      required: false,
      default: "dark",
    },

    placeholder: {
      type: String,
      required: false,
    },

    title: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },

    actionbuttontext: {
      type: String,
      default: "",
    },

    actionbuttonroute: {
      type: String,
      default: "",
    },
  },

  components: {
    InfoCard,
  },
};
</script>

<style lang="scss" scoped>
.info-card-body {
  .info-card-title {
  }
  .info-card-custom-content {
    .content-item {
      .title {
        * {
          display: inline;
        }
      }
    }
  }
}
</style>
